import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiBaseURL from "../ApiBaseUrl/ApiBaseURL";

import DashboardTripCountTotalHrs from "./DashboardTripCountTotalHrs";
import DashboardVehicleRefilling from "./DashboardVehicleRefilling";
import TopFiveWorkingVehicle from "./TopFiveWorkingVehicle";
import TopFiveFuleConsumed from "./TopFiveFuleConsumed";
import TopFiveVehicleAvg from "./TopFiveVehicleAvg";
import TopFiveWorkingEffiency from "./TopFiveWorkingEffiency";
import DashboardByVehicleUtlization from "./DashboardByVehicleUtlization";
import DashboardRemaningStocks from "./DashboardRemaningStocks";
import DashboardTripByShift from "./DashboardTripByShift";
import DashboardShiftWiseUtlization from "./DashboardShiftWiseUtlization";
import DashboardActiveVehicleTypeDetails from "./DashboardActiveVehicleTypeDetails";
import DashboardInActiveVehicleTypeDetails from "./DashboardInActiveVehicleTypeDetails";
import DashboardCubicMeter from "./DashboardCubicMeter";
import { useNavigate } from "react-router-dom";
import ReportTabularView from "./ReportTabularView";


const DashboardMain = () => {

    const [data, setData] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [allVendors, setAllVendors] = useState([]);
    const [allVehicles, setAllVehicles] = useState([]);
    const [allDrivers, setAllDrivers] = useState([]);

    const [vendors, setVendors] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [drivers, setDrivers] = useState([]);

    const [selectedVehicleType, setSelectedVehicleType] = useState('');
    const [selectedVendor, setSelectedVendor] = useState("");
    const [selectedVehicle, setSelectedVehicle] = useState("");
    const [selectedDriver, setSelectedDriver] = useState("");
    const [period, setPeriod] = useState("cm");

    const [viewMode, setViewMode] = useState('graph');

    const [topVendors, setTopVendors] = useState([]);

    const navigate = useNavigate();

    const [summary, setSummary] = useState({
        tripCount: 0,
        workingHours: 0,
        totalFuel: 0,
        totalAmount: 0,
        totalCubicMeterCount: 0,
        compositeRevenue: 0,
        rehandlingRevenue: 0,
        totalRevenue: 0,
        fuelPerTrip: 0,
        fuelPerHour: 0,
    });

    const handleReset = () => {
        setViewMode('graph');
        setSelectedVehicleType('');
        setSelectedVendor('');
        setSelectedDriver('');
        setSelectedVehicle('');
        setPeriod('cm');
    };

    useEffect(() => {
        fetchVehicleVendorDetails();
    }, []);

    useEffect(() => {
        fetchTripFuelSummary();
    }, [selectedVehicleType, selectedVendor, selectedVehicle, selectedDriver, period]);

    const fetchVehicleVendorDetails = async () => {
        const userId = localStorage.getItem("userId");
        const authToken = localStorage.getItem("token");

        if (!userId || !authToken) {
            toast.error("Missing userid or Authorization in localStorage");
            return;
        }

        try {
            const response = await fetch(`${ApiBaseURL}/dashboard/v1/get/vehicle-vendor-details`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    userId,
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({ vehicleTypeId: null }),
            });

            const result = await response.json();

            // if (response.ok && result.statusDescription.statusCode === 200) {
            //     setData(result.data || []);

            //     const types = result.data.map((item) => ({
            //         id: item.vehicleTypeId,
            //         name: item.vehicleTypeName,
            //         drivers: item.drivers || [],
            //         vendors: item.vendors || [],
            //     }));
            //     setVehicleTypes(types);

            //     const combinedVendors = result.data.flatMap((item) => item.vendors || []);
            //     setAllVendors(combinedVendors);

            //     const combinedVehicles = combinedVendors.flatMap((vendor) => vendor.vehicles || []);
            //     setAllVehicles(combinedVehicles);

            //     const combinedDrivers = result.data.flatMap((item) => item.drivers || []);
            //     setAllDrivers(combinedDrivers);

            //     setVendors(combinedVendors);
            //     setVehicles(combinedVehicles);
            //     setDrivers(combinedDrivers);
            // } 
            if (response.ok && result.statusDescription.statusCode === 200) {
                setData(result.data || []);

                const types = result.data.map((item) => ({
                    id: item.vehicleTypeId,
                    name: item.vehicleTypeName,
                    drivers: item.drivers || [],
                    vendors: item.vendors || [],
                }));

                setVehicleTypes(types);

                // ✅ Set default if "Tippers" (or similar) found
                // const tipper = types.find(t => t.name.toLowerCase().includes('tipper'));
                // if (tipper) {
                //     setSelectedVehicleType(tipper.id);
                // }

                const combinedVendors = result.data.flatMap((item) => item.vendors || []);
                setAllVendors(combinedVendors);

                const combinedVehicles = combinedVendors.flatMap((vendor) => vendor.vehicles || []);
                setAllVehicles(combinedVehicles);

                const combinedDrivers = result.data.flatMap((item) => item.drivers || []);
                setAllDrivers(combinedDrivers);

                setVendors(combinedVendors);
                setVehicles(combinedVehicles);
                setDrivers(combinedDrivers);
            } else if ([401, 403].includes(result.statusDescription.statusCode)) {
                toast.error(result.statusDescription.description || "Unauthorized access. Redirecting...");
                localStorage.clear();

                setTimeout(() => {
                    window.location.replace('/');
                }, 1500);
            }
            else {
                console.log(result.statusDescription.description || "Failed to fetch data");
            }
        } catch (error) {
            toast.error("Error fetching vehicle vendor details: " + error.message);
        }
    };

    const fetchTripFuelSummary = async () => {
        const userId = localStorage.getItem("userId");
        const authToken = localStorage.getItem("token");

        if (!userId || !authToken) {
            toast.error("Missing userid or Authorization in localStorage");
            return;
        }

        try {
            const response = await fetch(`${ApiBaseURL}/dashboard/v1/get/trip-fuel-summary`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    userId,
                    Authorization: `Bearer ${authToken}`,
                },
                // body: JSON.stringify({
                //     vehicleTypeId: selectedVehicleType || null,
                //     vendorId: selectedVendor || null,
                //     driverId: selectedDriver || null,
                //     vehicleId: selectedVehicle || null,
                //     period,
                // }),
                body: JSON.stringify({
                    vehicleTypeId: selectedVehicleType || null,
                    vendorId: selectedVendor || null,
                    driverId: selectedDriver || null,
                    vehicleId: selectedVehicle || null,
                    period,
                }),
            });

            const result = await response.json();

            if (response.ok && result.statusDescription.statusCode === 200) {
                setSummary(result.data || {});
            } else if ([401, 403].includes(result.statusDescription.statusCode)) {
                toast.error(result.statusDescription.description || "Unauthorized access. Redirecting...");
                localStorage.clear();

                setTimeout(() => {
                    window.location.replace('/');
                }, 1500);
            } else {
                console.log(result.statusDescription.description || "Failed to fetch trip fuel summary");
            }
        } catch (error) {
            toast.error("Error fetching trip fuel summary: " + error.message);
        }
    };

    const handleFetchTop3Vendors = async () => {

        const userId = localStorage.getItem("userId");
        const authToken = localStorage.getItem("token");

        try {
            const response = await fetch(`${ApiBaseURL}/dashboard/v1/get/top-vendors`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                    'userId': userId,
                },
                body: JSON.stringify({
                    period,
                    // vendorId: selectedVendor
                    vehicleTypeId: selectedVehicleType
                }),
            });
            console.log("Sending vendorId:", selectedVendor);
            const result = await response.json();

            if (result.statusDescription.statusCode === 200) {
                setTopVendors(result.data);
            } else {
                console.error('API Error:', result.statusDescription.description);
            }

        } catch (error) {
            console.error('Fetch error:', error);
        }
    };

    useEffect(() => {
        handleFetchTop3Vendors();
    }, [period, selectedVehicleType]);

    const handleVehicleTypeChange = (e) => {
        const selectedId = e.target.value;
        setSelectedVehicleType(selectedId);
        setSelectedVendor("");
        setSelectedVehicle("");
        setSelectedDriver("");

        if (!selectedId) {
            setVendors(allVendors);
            setVehicles(allVehicles);
            setDrivers(allDrivers);
            return;
        }

        const vehicleType = data.find((item) => item.vehicleTypeId.toString() === selectedId);

        if (vehicleType) {
            setVendors(vehicleType.vendors);
            setDrivers(vehicleType.drivers);
            const vehiclesFromVendors = vehicleType.vendors.flatMap((v) => v.vehicles || []);
            setVehicles(vehiclesFromVendors);
        } else {
            setVendors([]);
            setDrivers([]);
            setVehicles([]);
        }
    };

    const handleVendorChange = (e) => {
        const selectedId = e.target.value;
        console.log("Selected from dropdown:", e.target.value);
        console.log("Selected from dropdown:", e.target.value);
        setSelectedVendor(selectedId);
        setSelectedVehicle("");

        if (!selectedId) {
            if (selectedVehicleType) {
                const vehicleType = data.find((item) => item.vehicleTypeId.toString() === selectedVehicleType);
                if (vehicleType) {
                    const vehiclesFromVendors = vehicleType.vendors.flatMap((v) => v.vehicles || []);
                    setVehicles(vehiclesFromVendors);
                    return;
                }
            }
            setVehicles(allVehicles);
            return;
        }

        const vendor = vendors.find((item) => item.vendorId.toString() === selectedId);

        if (vendor) {
            setVehicles(vendor.vehicles || []);
        } else {
            setVehicles([]);
        }
    };

    const handleVehicleChange = (e) => {
        setSelectedVehicle(e.target.value);
    };

    const handleDriverChange = (e) => {
        setSelectedDriver(e.target.value);
    };

    const handleViewModeChange = (mode) => {
        setViewMode(mode);
        if (mode === 'graph') {
            navigate('/dshbd');
        } else if (mode === 'table') {
            navigate('/tabular-report', {
                state: {
                    vehicleTypeId: selectedVehicleType || null,
                    vendorId: selectedVendor || null,
                    driverId: selectedDriver || null,
                    vehicleId: selectedVehicle || null,
                    period,
                }
            });
        }
    };

    return (
        <div className="container mt-3">
            <div className="row align-items-center mb-3">
                <div className="col d-flex justify-content-end align-items-center">
                    <div className="form-check form-check-inline mb-0">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="viewMode"
                            id="graphicalView"
                            value="graph"
                            checked={viewMode === 'graph'}
                            onChange={() => handleViewModeChange('graph')}
                        />
                        <label className="form-check-label" htmlFor="graphicalView" style={{ cursor: "pointer" }}>
                            Graphical View
                        </label>
                    </div>

                    <div className="form-check form-check-inline mb-0 ms-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="viewMode"
                            id="tabularView"
                            value="table"
                            checked={viewMode === 'table'}
                            onChange={() => handleViewModeChange('table')}
                        />
                        <label className="form-check-label" htmlFor="tabularView" style={{ cursor: "pointer" }}>
                            Tabular View
                        </label>
                    </div>

                    <button
                        className="btn btn-outline-secondary ms-4"
                        title="Reset"
                        onClick={handleReset}
                    >
                        <i className="fa-solid fa-rotate"></i>
                    </button>
                </div>
            </div>

            <div className="row g-3 mb-3">
                <div className="col-md-4">
                    <label htmlFor="vehicleType" className="form-label">Vehicle Type</label>
                    <select
                        className="form-select"
                        id="vehicleType"
                        value={selectedVehicleType}
                        onChange={handleVehicleTypeChange}
                    >
                        <option value="">All</option>
                        {vehicleTypes.map((type) => (
                            <option key={`vehicle-type-${type.id}`} value={type.id}>
                                {type.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-4">
                    <label htmlFor="vendor" className="form-label">Vendor</label>
                    <select
                        className="form-select"
                        id="vendor"
                        value={selectedVendor}
                        onChange={handleVendorChange}
                        disabled={vendors.length === 0}
                    >
                        <option value="">All</option>
                        {vendors.map((vendor) => (
                            <option key={vendor.vendorId} value={vendor.vendorId}>
                                {vendor.vendorName}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-4">
                    <label htmlFor="vehicleNumber" className="form-label">Vehicle Number</label>
                    <select
                        className="form-select"
                        id="vehicleNumber"
                        value={selectedVehicle}
                        onChange={handleVehicleChange}
                        disabled={vehicles.length === 0}
                    >
                        <option value="">All</option>
                        {vehicles.map((vehicle) => (
                            <option key={vehicle.vehicleId} value={vehicle.vehicleId}>
                                {vehicle.registrationNumber}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-9 d-flex align-items-center justify-content-center">
                    <div className="d-flex flex-wrap gap-2">
                        <label htmlFor="filterSelect" className="form-label mb-1">Top 3 Vendors</label>

                        {topVendors.map((vendor) => (
                            <button
                                key={vendor.vendorId}
                                type="button"
                                className={`btn btn-primary ${selectedVendor === vendor.vendorId ? 'active' : ''}`}
                                onClick={() => {
                                    console.log("Clicked vendorId:", vendor.vendorId);
                                    setSelectedVendor(vendor.vendorId);
                                }}
                            >
                                {vendor.vendorName}
                            </button>
                        ))}
                    </div>
                    {/* <i
                        className="fa-regular fa-circle-xmark"
                        onClick={handleReset}
                        title="Reset"
                        style={{ cursor: 'pointer', margin: 'revert', padding: '10px' }}
                    ></i> */}
                </div>

                <div className="col-md-3">
                    <label htmlFor="filterSelect" className="form-label">Filter Period</label>

                    <div className="d-flex flex-column align-items-md-end">
                        <select
                            className="form-select"
                            aria-label="Filter options"
                            id="filterSelect"
                            value={period}
                            onChange={(e) => setPeriod(e.target.value)}
                        >
                            <option value="y-25">Year-25</option>
                            <option value="today">Today</option>
                            <option value="yesterday">Yesterday</option>
                            <option value="week">Week</option>
                            <option value="cm">Current Month</option>
                            <option value="pm">Prev. Month</option>
                            <option value="3m">3M</option>
                            <option value="6m">6M</option>
                            <option value="9m">9M</option>
                        </select>
                    </div>
                </div>
                {/* </div> */}

                <div className="col-md-2">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Trips Count</h6>
                            <p className="card-text display-10 fw-bold" id="totalTrips">
                                {new Intl.NumberFormat('en-IN').format(Math.round(summary.tripCount ?? 0))}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-md-2">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Work Done</h6>
                            <p className="card-text display-10 bold-text" id="totalCubicMeterCount" style={{ fontWeight: 'bold' }}>
                                {new Intl.NumberFormat('en-IN').format(Math.round(summary.totalCubicMeterCount))} m³
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Composite Revenue</h6>
                            <p className="card-text display-10 bold-text" id="compositeRevenue" style={{ fontWeight: 'bold' }}>
                                ₹{new Intl.NumberFormat('en-IN').format(Math.round(summary.compositeRevenue))}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Rehandling Revenue</h6>
                            <p className="card-text display-10 bold-text" id="rehandlingRevenue" style={{ fontWeight: 'bold' }}>
                                ₹{new Intl.NumberFormat('en-IN').format(Math.round(summary.rehandlingRevenue))}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Total Revenue</h6>
                            <p className="card-text display-10 bold-text" id="totalRevenue" style={{ fontWeight: 'bold' }}>
                                ₹{new Intl.NumberFormat('en-IN').format(Math.round(summary.totalRevenue))}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-md-2">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Fuel Cons.</h6>
                            <p className="card-text display-10 bold-text" id="totalFuel" style={{ fontWeight: 'bold' }}>
                                {new Intl.NumberFormat('en-IN').format(Math.round(summary.totalFuel))} Ltr.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-md-2">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Fuel Costs</h6>
                            <p className="card-text display-10 bold-text" id="totalCost" style={{ fontWeight: 'bold' }}>
                                ₹{new Intl.NumberFormat('en-IN').format(Math.round(summary.totalAmount))}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Fuel Cons. Per Trip</h6>
                            <p className="card-text display-10 bold-text" id="fuelPerTrip" style={{ fontWeight: 'bold' }}>
                                {new Intl.NumberFormat('en-IN').format(Math.round(summary.fuelPerTrip))} Ltr.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Machine Hours</h6>
                            <p className="card-text display-10 bold-text" id="totalWorkingHours" style={{ fontWeight: 'bold' }}>
                                {new Intl.NumberFormat('en-IN').format(Math.round(summary.workingHours))} Hrs.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card text-dark text-center" style={{ backgroundColor: "#FFFFFF" }}>
                        <div className="card-body">
                            <h6 className="card-title" style={{ color: "#0C88C2" }}>Fuel Cons. Per Machine Hrs.</h6>
                            <p className="card-text display-10 bold-text" id="fuelPerHour" style={{ fontWeight: 'bold' }}>
                                {new Intl.NumberFormat('en-IN').format(Math.round(summary.fuelPerHour))} Ltr.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-md-6">
                    <DashboardTripCountTotalHrs
                        vehicleTypeId={selectedVehicleType}
                        vendorId={selectedVendor}
                        driverId={selectedDriver}
                        vehicleId={selectedVehicle}
                        period={period}
                    />
                </div>

                <div className="col-md-6">
                    <DashboardCubicMeter
                        vehicleTypeId={selectedVehicleType}
                        vendorId={selectedVendor}
                        driverId={selectedDriver}
                        vehicleId={selectedVehicle}
                        period={period}
                    />
                </div>

                <div className="col-md-6">
                    <DashboardRemaningStocks
                        period={period}
                    />
                </div>

                <div className="col-md-6">
                    <DashboardVehicleRefilling
                        vehicleTypeId={selectedVehicleType}
                        vendorId={selectedVendor}
                        driverId={selectedDriver}
                        vehicleId={selectedVehicle}
                        period={period}
                    />
                </div>

                <div className="col-md-6">
                    <DashboardTripByShift
                        vehicleTypeId={selectedVehicleType}
                        vendorId={selectedVendor}
                        driverId={selectedDriver}
                        vehicleId={selectedVehicle}
                        period={period}
                    />
                </div>

                <div className="col-md-3">
                    <DashboardByVehicleUtlization
                        vehicleTypeId={selectedVehicleType}
                        vendorId={selectedVendor}
                        driverId={selectedDriver}
                        vehicleId={selectedVehicle}
                        period={period}
                    />
                </div>

                <div className="col-md-3">
                    <DashboardShiftWiseUtlization
                        vehicleTypeId={selectedVehicleType}
                        vendorId={selectedVendor}
                        driverId={selectedDriver}
                        vehicleId={selectedVehicle}
                        period={period}
                    />
                </div>

                <div className="col-md-6">
                    <TopFiveWorkingVehicle
                        vehicleTypeId={selectedVehicleType}
                        vendorId={selectedVendor}
                        driverId={selectedDriver}
                        vehicleId={selectedVehicle}
                        period={period}
                    />
                </div>

                <div className="col-md-6">
                    <TopFiveFuleConsumed
                        vehicleTypeId={selectedVehicleType}
                        vendorId={selectedVendor}
                        driverId={selectedDriver}
                        vehicleId={selectedVehicle}
                        period={period}
                    />
                </div>

            </div>
        </div>
    );
};

export default DashboardMain;